// localization-button-onclick
document.querySelectorAll('[aria-controls="localization-popup"]').forEach((el) => {
    el.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('show-localization-popup', {detail: el}));
    });
})

document.querySelectorAll('.total_color_text').forEach((el) => {
    el.addEventListener('click', () => {
        el.classList.toggle('is-visible');
    });
})

document.querySelectorAll('[data-logout-link]').forEach((el) => {
    el.addEventListener('click', (e) => {
        e.preventDefault();
        // cookieStore.delete('cart');
        document.cookie = "cart=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/"
        window.location.href = el.getAttribute('href');
    });
});

document.addEventListener('cart:discount:refreshed', (e) => {
    const form = document.querySelector(`form#${e.detail.form}`);
    form.submit();
});

function addDiscountValidator() {
    document.querySelectorAll('.button-proceed-checkout').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            el.setAttribute('disabled', '');
            new UpdateCartDiscounts(el.getAttribute('form'));
        });
    });
}

document.addEventListener('cart:drawer:shown', (e) => {
    addDiscountValidator();
});

document.addEventListener('DOMContentLoaded', () => {
    addDiscountValidator();
})
